// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form__title[data-v-b61a822a] {\n    display: block;\n    margin-top: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
